<template>
  <div class="previewImage-warp" v-if="images && images.length">
    <viewer class="viewer-warp" :images="images" ref="viewer" @inited="inited">
      <img
        v-for="(src, index) in images"
        :src="src[valueKey]"
        :key="index"
        style="display: none"
      />
    </viewer>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  components: {},
  props: {
    images: {
      default: () => [],
      type: Array,
    },
    // 作为 value 唯一标识的键名，绑定值为对象类型时必填
    valueKey: {
      default: () => "url",
      type: String,
    },
    // 单张可以忽略
    previewIndex: {
      default: () => 0,
      type: Number,
    },
  },
  created() {},
  methods: {
    inited(viewer) {
      this.$viewer = viewer;
      this.$viewer.index = this.previewIndex;
      this.$viewer.options.title = false;
      this.$viewer.options.fullscreen = false;
      this.$viewer.options.keyboard = false;
      this.$viewer.options.loop = false;
      this.$viewer.options.movable = false;
      this.$viewer.options.zoomRatio = 1;
      this.$viewer.show();
    },
  },
};
</script>
